// LIST OF SEARCH RESULT
import {Model} from "@/store/models/model"

export class DomainSearchResult extends Model {
  static entity = 'domainsearchresult'
  static primaryKey = 'name'
  static fields() {
    return {
      id:this.attr(null),
      name:this.attr(null),
      available: this.attr(null),
      selected: this.attr(true),
      price:this.attr(null),
      year:this.attr(1),
      sld:this.attr(null),
      tld:this.attr(null),
      spinner: this.attr(false),
      error:this.attr(null),
      success:this.attr(false)
    }
  }
  static  deleteSearchItem(index) {
    console.log('INDEX:::',index)
    const x =  DomainSearchResult.query().where('name', index).get()
    DomainSearchResult.delete(index)
  }
}

export default DomainSearchResult



// WEBPACK FOOTER //
// ./src/store/models/layout/domain_search_result.js